var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fail-message"},[_vm._v("\n "+_vm._s(_vm.failMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }